<script setup lang="ts">
import type { CreditSearchSubject } from '@/models/credit-search/api'
import { subjectSelectionKey } from '@/models/credit-search/selection'

defineOptions({ name: 'CreditSearchSubjectResultTable' })

defineProps<{
  subjects: CreditSearchSubject[]
  selectedKeys: ReadonlySet<string>
}>()

const emit = defineEmits<{
  select: [subject: CreditSearchSubject]
  remove: [subject: CreditSearchSubject]
}>()
</script>

<template>
  <table class="table table-sm">
    <thead>
      <tr>
        <th>Code</th>
        <th>Name</th>
        <th>Institution</th>
        <th></th>
      </tr>
    </thead>
    <tbody id="RuleListTableBody">
      <tr v-for="subject in subjects" :key="subjectSelectionKey(subject)">
        <td>{{ subject.subject_code }}</td>
        <td>{{ subject.subject_name }}</td>
        <td>{{ subject.institution_name }}</td>
        <td>
          <button
            type="button"
            class="btn btn-primary btn-sm"
            :class="{ hidden: selectedKeys.has(subjectSelectionKey(subject)) }"
            @click="emit('select', subject)"
          >Select</button>
          <button
            type="button"
            class="btn btn-danger btn-sm"
            :class="{ hidden: !selectedKeys.has(subjectSelectionKey(subject)) }"
            @click="emit('remove', subject)"
          >Remove</button>
        </td>
      </tr>
      <tr v-if="subjects.length === 0">
        <td colspan="4">No Results - If you have completed subjects not listed, you may still apply for them to be assessed for credit.</td>
      </tr>
    </tbody>
  </table>
</template>

<style lang="scss" scoped>
.hidden {
  display: none;
}

td:last-child {
  white-space: nowrap;
}
</style>
